(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hw-landing-giftcard"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.__hwGc) return; window.__hwGc = true;
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-gc-variant]'); if (!b) return;
    var sec = b.closest('.hw-gc'); if (!sec) return;
    sec.querySelectorAll('[data-gc-variant]').forEach(function(x){ x.classList.toggle('is-on', x === b); });
    sec.querySelector('[data-gc-id]').value = b.dataset.gcVariant;
    var l = sec.querySelector('[data-gc-amount-label]'); if (l) l.textContent = b.dataset.label;
  });
  document.addEventListener('input', function(e){
    var i = e.target.closest('[data-gc-in]'); if (!i) return;
    var sec = i.closest('.hw-gc'); if (!sec) return;
    if (i.dataset.gcIn === 'name') { var n = sec.querySelector('[data-gc-name]'); n.textContent = i.value || n.dataset.ph; }
    else { sec.querySelector('[data-gc-msg]').textContent = i.value; }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-landing-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.__hwLanding) return; window.__hwLanding = true;
  var POP = '#es-popup-button,.es-popup-button,[data-es-popup-trigger]';
  function order(){
    var box = document.querySelector('.hw-order');
    if (box) {
      var embedded = box.querySelector('input:not([type=hidden]),select,textarea');
      if (!embedded) {
        var btn = box.querySelector(POP + ',button,[role=button]');
        if (btn) { btn.click(); return; }
      }
      var y = box.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo({top: y, behavior: 'smooth'});
      return;
    }
    var f = document.querySelector(POP + ',form[action*="/cart/add"] [type=submit]');
    if (f) f.click();
  }
  window.hwOrder = order;
  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-hw-order]');
    if (!t || e.target.closest('.hw-order')) return;
    e.preventDefault(); order();
  });

  function pad(n){return (n<10?'0':'')+n}
  function initTimer(el){
    if (el.dataset.ready) return; el.dataset.ready = 1;
    var mode = el.dataset.mode, hrs = parseFloat(el.dataset.hours)||6, key = el.dataset.key, end;
    function reset(){
      if (mode === 'hours') {
        var now = Date.now();
        try { end = parseInt(localStorage.getItem(key),10); } catch(e){}
        if (!end || end <= now) { end = now + hrs*3600000; try{localStorage.setItem(key,end)}catch(e){} }
      } else { var d = new Date(); d.setHours(23,59,59,999); end = d.getTime(); }
    }
    reset();
    var H=el.querySelector('[data-h]'),M=el.querySelector('[data-m]'),S=el.querySelector('[data-s]');
    (function tick(){
      var left = end - Date.now();
      if (left <= 0) { reset(); left = end - Date.now(); }
      var s = Math.floor(left/1000);
      H.textContent = pad(Math.floor(s/3600)); M.textContent = pad(Math.floor(s%3600/60)); S.textContent = pad(s%60);
      setTimeout(tick, 1000);
    })();
  }
  function initViewers(el){
    if (el.dataset.ready) return; el.dataset.ready = 1;
    var min = +el.dataset.min||12, max = Math.max(+el.dataset.max||48, min), v = Math.round(min + Math.random()*(max-min));
    el.textContent = v;
    setInterval(function(){ var o = v; v += Math.round(Math.random()*4) - 2; v = Math.min(max, Math.max(min, v)); if (v !== o) { el.textContent = v; el.classList.add('is-bump'); setTimeout(function(){ el.classList.remove('is-bump'); }, 260); } }, 4500);
  }
  function initSlider(track){
    if (track.dataset.ready) return; track.dataset.ready = 1;
    var dots = track.parentNode.querySelectorAll('[data-hw-dots] button');
    if (!dots.length) return;
    dots.forEach(function(b,i){ b.addEventListener('click', function(e){ e.stopPropagation(); track.scrollTo({left: (track.scrollLeft < 0 || getComputedStyle(track).direction === 'rtl' ? -1 : 1) * i * track.clientWidth, behavior:'smooth'}); }); });
    track.addEventListener('scroll', function(){
      var i = Math.round(Math.abs(track.scrollLeft) / track.clientWidth);
      dots.forEach(function(b,j){ b.classList.toggle('is-on', i===j); });
    }, {passive:true});
  }
  function initSticky(bar){
    if (bar.dataset.ready) return; bar.dataset.ready = 1;
    var cta = document.querySelector('.hw-hero .hw-btn[data-hw-order]'), box = document.querySelector('.hw-order');
    if (!('IntersectionObserver' in window)) return;
    var ctaGone = !cta, boxSeen = false;
    function upd(){ bar.classList.toggle('is-on', ctaGone && !boxSeen); }
    if (cta) new IntersectionObserver(function(es){ var r = es[0]; ctaGone = !r.isIntersecting && r.boundingClientRect.top < 0; upd(); }).observe(cta);
    if (box) new IntersectionObserver(function(es){ boxSeen = es[0].isIntersecting; upd(); }, {rootMargin:'0px 0px -25% 0px'}).observe(box);
    upd();
  }
  function initStock(el){
    if (el.dataset.ready) return; el.dataset.ready = 1;
    var n = +el.dataset.left, min = +el.dataset.min || 3, total = +el.dataset.total || 100, key = el.dataset.key;
    var N = el.querySelector('[data-n]'), bar = el.querySelector('[data-bar]');
    try { var saved = parseInt(sessionStorage.getItem(key),10); if (saved && saved < n) n = Math.max(min, saved); } catch(e){}
    function show(){ if (N) N.textContent = n; if (bar) bar.style.width = Math.max(4, n/total*100) + '%'; }
    show();
    if (el.dataset.drop !== 'true') return;
    (function step(){ setTimeout(function(){ if (n > min) { n--; show(); try{sessionStorage.setItem(key,n)}catch(e){} step(); } }, 25000 + Math.random()*35000); })();
  }
  function init(){
    document.querySelectorAll('[data-hw-stock]').forEach(initStock);
    document.querySelectorAll('[data-hw-timer]').forEach(initTimer);
    document.querySelectorAll('[data-hw-viewers]').forEach(initViewers);
    document.querySelectorAll('[data-hw-slider]').forEach(initSlider);
    document.querySelectorAll('[data-hw-sticky]').forEach(initSticky);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-landing-ugc"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.__hwUgc) return; window.__hwUgc = true;
  document.addEventListener('click', function(e){
    var shot = e.target.closest('.hw-ugc__shot');
    var sec = e.target.closest('.hw');
    if (shot && sec) {
      var lb = sec.querySelector('[data-hw-lb]'); if (!lb) return;
      lb.querySelector('[data-hw-lb-img]').src = shot.dataset.full; lb.hidden = false; return;
    }
    var box = e.target.closest('[data-hw-lb]');
    if (box && (e.target === box || e.target.closest('.hw-lb__x'))) box.hidden = true;
  });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') document.querySelectorAll('[data-hw-lb]').forEach(function(l){ l.hidden = true; }); });
})();

  } catch(e) { console.error(e); }
})();
})();
